import { Lazy } from '@betgames/bg-state-manager';
import { storageRepository } from '@betgames/bg-tools';
import { authDecorator } from 'decorators/AuthDecorator';
import { sentryRepository } from 'repositories/SentryRepository';
import { webSocketsRepository } from 'repositories/WebSockets';
import AuthRepository from './Auth.repository';
import AuthStore from './Auth.store';

export const auth = new Lazy(
    () =>
        new AuthStore(
            new AuthRepository(authDecorator),
            storageRepository,
            sentryRepository,
            webSocketsRepository,
        ),
);
export { authSelectors } from './Auth.selectors';
